import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
@Injectable()
export class MicrofrontendOverlayContainer extends OverlayContainer {
  _createContainer(): void {
    const container = document.createElement('div');
    container.classList.add('persona-overlay-container');

    document.body.appendChild(container);
    this._containerElement = container;
  }
}
